import { useContext } from 'react'
import { HealthModeContext } from 'components/HealthModeProvider'

export const useHealthMode = () => useContext(HealthModeContext)
